@if (dispatchCampaign(); as dispatchCampaign) {
    <div>
        <!-- ALL_CUSTOMERS -->
        @if (filterMode() == 'ALL_CUSTOMERS' && dispatchCampaign.targetFilter?.modeSettings?.ALL_CUSTOMERS; as allCustomers) {
            <section class="flex! flex-col! w-full" (animate.enter)="animateStepIn($event)">
                <div>
                    <p translate>DISPATCH_CAMPAIGN_TARGET_MODE_ALL_CUSTOMERS_INFO</p>
                </div>

                <div class="w-full">
                    <p-select
                        [options]="clients()"
                        [(ngModel)]="allCustomers.clientIds"
                        [multiple]="true"
                        [filter]="false"
                        optionLabel="name"
                        optionValue="_id"
                        appendTo="body"
                        placeholder="{{ 'CLIENT' | translate }}"
                        [fluid]="true"
                        (onChange)="ALL_CUSTOMERS_clientIdsChanged()"></p-select>
                </div>
            </section>
        }
        <!-- SPECIFIC_PACKAGES -->
        @if (filterMode() == 'SPECIFIC_PACKAGES' && dispatchCampaign.targetFilter?.modeSettings?.SPECIFIC_PACKAGES; as specificPackages) {
            <section class="flex! flex-col! gap-2 w-full" (animate.enter)="animateStepIn($event)">
                <div>
                    <p translate>DISPATCH_CAMPAIGN_TARGET_MODE_SPECIFIC_PACKAGES_INFO</p>
                </div>
                <p-select
                    class="w-full"
                    [(ngModel)]="specificPackages.clientId"
                    (onChange)="SPECIFIC_PACKAGES_clientIdChanged()"
                    [options]="clients()"
                    optionValue="_id"
                    optionLabel="name"
                    size="large"
                    placeholder="CLIENT"></p-select>

                <br />

                @if (specificPackages.clientId; as clientId) {
                    <div (animate.enter)="animateStepIn($event)">
                        <p-select
                            class="w-full"
                            appendTo="body"
                            size="large"
                            [options]="availablePackagesByClient[clientId]"
                            [(ngModel)]="specificPackages.packageIds"
                            [multiple]="true"
                            [filter]="false"
                            [loading]="packagesLoading()"
                            optionLabel="name"
                            optionValue="id"
                            (onChange)="SPECIFIC_PACKAGES_packageIdsChanged()"
                            placeholder="{{ 'PACKAGES' | translate }}" />
                    </div>
                }
            </section>
        }
        <!-- NOT_BOOKED_SINCE -->
        @if (filterMode() == 'NOT_BOOKED_SINCE' && dispatchCampaign.targetFilter?.modeSettings?.NOT_BOOKED_SINCE; as notBookedSince) {
            <section class="flex! flex-col! gap-2 w-full" (animate.enter)="animateStepIn($event)">
                <div>
                    <p translate>DISPATCH_CAMPAIGN_TARGET_MODE_NOT_BOOKED_SINCE_INFO</p>
                </div>
                <div class="flex!">
                    <p-select
                        class="w-full!"
                        [options]="clients()"
                        [(ngModel)]="notBookedSince.clientIds"
                        [multiple]="true"
                        [filter]="false"
                        [fluid]="true"
                        optionLabel="name"
                        size="large"
                        optionValue="_id"
                        (onChange)="NOT_BOOKED_SINCE_clientIdsChanged()"
                        appendTo="body"
                        placeholder="{{ 'CLIENT' | translate }}" />
                </div>
                <div class="flex! gap-2!">
                    <p-datepicker
                        [fluid]="true"
                        class="w-full"
                        size="large"
                        appendTo="body"
                        [(ngModel)]="notBookedSince.notBookedSince"
                        placeholder="{{ 'DISPATCH_CAMPAIGN_TARGET_MODE_NOT_BOOKED_SINCE_DATE' | translate }}"
                        [showIcon]="true"
                        iconDisplay="input"
                        (onBlur)="NOT_BOOKED_SINCE_notBookedSinceChanged()"></p-datepicker>
                    <p-datepicker
                        class="w-full"
                        [fluid]="true"
                        size="large"
                        [timeOnly]="true"
                        iconDisplay="input"
                        appendTo="body"
                        [(ngModel)]="notBookedSince.notBookedSince"
                        placeholder="{{ 'DISPATCH_CAMPAIGN_TARGET_MODE_NOT_BOOKED_SINCE_DATE' | translate }}"
                        [showIcon]="true"
                        (onBlur)="NOT_BOOKED_SINCE_notBookedSinceChanged()">
                        <ng-template #inputicon let-clickCallBack="clickCallBack">
                            <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                        </ng-template>
                    </p-datepicker>
                </div>
            </section>
        }
    </div>
}
